// src/components/PrivacyPolicy.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faShield, 
  faArrowLeft, 
  faLock, 
  faDatabase, 
  faUserShield, 
  faInfoCircle,
  faUserNinja
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-header">
        <button 
          className="back-button"
          onClick={() => navigate(-1)}
        >
          <FontAwesomeIcon icon={faArrowLeft} /> Back
        </button>
        <h1><FontAwesomeIcon icon={faShield} /> Privacy Policy</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <div className="privacy-policy-content">
        <section className="policy-section">
          <h2><FontAwesomeIcon icon={faInfoCircle} /> 1. Information We Collect</h2>
          <p>When you use V Editor, we may collect:</p>
          <ul>
            <li><strong>Guest Users:</strong> Session information, anonymous usage data, and feedback content</li>
            <li><strong>Registered Users:</strong> Your name, email address, professional position/role</li>
            <li>Feedback content and ratings</li>
            <li>Browser type and device information</li>
            <li>Usage patterns and feature interactions</li>
          </ul>
          <p className="note"><FontAwesomeIcon icon={faUserNinja} /> Guest users remain anonymous - we don't collect personal identifiers unless voluntarily provided in feedback.</p>
        </section>

        <section className="policy-section">
          <h2><FontAwesomeIcon icon={faDatabase} /> 2. How We Use Your Information</h2>
          <p>We use the collected information to:</p>
          <ul>
            <li>Improve V Editor features and user experience for all users (including guests)</li>
            <li>Analyze anonymous usage patterns for product development</li>
            <li>Respond to user inquiries (if contact information provided)</li>
            <li>Maintain service security and prevent abuse</li>
            <li>Generate aggregated statistics about feature usage</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2><FontAwesomeIcon icon={faLock} /> 3. Data Storage and Security</h2>
          <p>Your data is protected with industry-standard security:</p>
          <ul>
            <li><strong>Guest Sessions:</strong> Temporary session data is automatically deleted after 30 days of inactivity</li>
            <li><strong>Registered Users:</strong> Data is encrypted and stored securely on protected servers</li>
            <li>All data transmissions use TLS encryption</li>
            <li>Access restricted to authorized personnel only</li>
            <li>Regular security audits and updates</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2><FontAwesomeIcon icon={faUserShield} /> 4. Your Rights</h2>
          <p>All users, including guests, have the right to:</p>
          <ul>
            <li><strong>Guest Users:</strong> Remain anonymous while using basic features</li>
            <li>Request deletion of any personal data you've provided</li>
            <li>Opt-out of non-essential data collection</li>
            <li>Access information about how your data is used</li>
            <li><strong>Registered Users:</strong> Access, correct, or export your personal data</li>
            <li>Withdraw consent for data processing at any time</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Guest User Information</h2>
          <p><FontAwesomeIcon icon={faUserNinja} /> As a guest user, you should know:</p>
          <ul>
            <li>No account or registration required for basic features</li>
            <li>Your session is temporary and not linked to any personal identifier</li>
            <li>Anonymous usage data helps us improve the service</li>
            <li>You can provide feedback without creating an account</li>
            <li>If you provide an email in feedback, it's only used for follow-up</li>
            <li>Session data is automatically cleared after 30 days</li>
          </ul>
          <p className="highlight">We respect your privacy - you can use V Editor's core features completely anonymously.</p>
        </section>

        <section className="policy-section">
          <h2>6. Contact Information</h2>
          <p>For privacy-related inquiries:</p>
          <ul>
            <li><strong>Email:</strong> <a href="mailto:veditort@gmail.com">veditort@gmail.com</a></li>
            <li><strong>Response Time:</strong> Within 48 hours</li>
          </ul>
        </section>
      </div>

      <div className="privacy-policy-footer">
        <button 
          className="action-btn"
          onClick={() => navigate('/')}
        >
          <FontAwesomeIcon icon={faArrowLeft} /> Back to Home
        </button>
        <p className="copyright">© {new Date().getFullYear()} V Editor • All rights reserved</p>
        <p className="guest-notice"><FontAwesomeIcon icon={faUserNinja} /> Guest friendly • No account required</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;